export const getPageData = (store: Store) => store.pages.pageData;
export const getIsLoadingPage = (store: Store) => store.pages.isLoadingPage;
export const getCurrentPageSlug = (store: Store) => store.pages.currentPageSlug;

export const getIsPageSaved = (store: Store) => store.pages.isSaved;
export const getIsSavingPage = (store: Store) => store.pages.isSavingPage;
export const getIsPublishing = (store: Store) => store.pages.isPublishing;
